import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { OrderService } from 'src/app/_services/order.service';
import { Order } from 'src/app/_models/order';
import { IPagination } from 'src/app/_models/pagination';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-orders-list',
    templateUrl: './orders-list.component.html',
    styleUrls: ['./orders-list.component.css'],
    standalone: false
})
export class OrdersListComponent implements OnInit {

    loading = true;
    orders: Order[];
    config: any;
    page = '1';
    lang = 'fr';

    constructor(private titleService: Title,
        private orderService: OrderService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private translateService: TranslateService) {
        this.lang = this.translateService.currentLang;
        this.page = this.activatedRoute.snapshot.queryParamMap.get('page') ?? '1';
        this.page = this.page == null ? '1' : this.page;
    }

    ngOnInit(): void {
        this.loadOrders();
    }

    loadOrders() {
        this.loading = true;
        this.orderService
            .loadOrdersByAdmin(parseInt(this.page, 10))
            .subscribe((res: IPagination) => this.setConfig(res), () => this.loading = false, () => this.loading = false);
    }

    pageChange(page) {
        this.page = page;
        this.router.navigate(['/admin/orders'], { queryParams: { page: page } });
        this.loadOrders();
    }

    getStatusClass(status: string): string {
        switch (status?.toUpperCase()) {
            case 'PENDING': return 'badge bg-warning text-dark';
            case 'CONFIRMED': return 'badge bg-primary';
            case 'SUCCESS': return 'badge bg-success';
            case 'SHIPPED': return 'badge bg-purple';
            case 'DELIVERED': return 'badge bg-success';
            case 'CANCELLED': return 'badge bg-danger';
            default: return 'badge bg-secondary';
        }
    }

    getPaymentMethodLabel(method: string): string {
        switch (method) {
            case 'FLUTTERWAVE': return 'Flutterwave';
            case 'CompanyMobileMoney': return 'Mobile Money';
            case 'COMPANY_MOBILE_MONEY': return 'Mobile Money';
            case 'CashOnDelivery': return 'Cash On Delivery';
            default: return method || '';
        }
    }

    formatDate(dateStr: string): string {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        const options: Intl.DateTimeFormatOptions = { month: 'long', day: 'numeric', year: 'numeric' };
        return date.toLocaleDateString(this.lang === 'fr' ? 'fr-FR' : 'en-US', options);
    }

    formatCurrency(amount: number, currency?: string): string {
        if (amount == null) return '';
        return new Intl.NumberFormat(this.lang === 'fr' ? 'fr-FR' : 'en-US').format(amount) + ' ' + (currency || 'XAF');
    }

    private setConfig(result: IPagination) {
        this.orders = result.data;
        this.config = {
            currentPage: result.page,
            itemsPerPage: result.itemPerPage,
            totalItems: result.totalOfItems,
            totalOfPage: result.totalOfPage,
            id: 'adminOrders'
        };
    }

}
